export default __webpack_public_path__ + "static/media/IconDesc_ModularFrame.64.c25c2f78.png";